import { Box, Flex, Group, Image, Loader, MultiSelect, Paper, Text } from "@mantine/core"
import { useDebouncedCallback } from "@mantine/hooks"
import { useEffect, useState } from "react"
import { getAllProductsList } from "../../../services/products"

const InputProductActionBanner = ({ dataProductIds, onChange, isError }) => {
  const [productIds, setProductIds] = useState([])

  const [storeSelectedProduct, setStoreSelectedProduct] = useState([])

  const [productList, setProductList] = useState([])
  const [productCount, setProductCount] = useState(0)
  const [loadingProducts, setLoadingProducts] = useState(true)
  const [searchProduct, setSearchProduct] = useState('')

  const handleGetProductListSelected = async (productIds) => {
    const parameter = {
      'filter[id][in]': productIds,
      'page[num]': 1,
      'page[limit]': 20,
    }
    try {
      const response = await getAllProductsList(parameter)
      const responseProduct = response.data
      const remapDataProduct = responseProduct.map((val) => {
        return {
          label: val.attributes.title,
          value: `${val.attributes.id}`,
          image: val.attributes.image
        }
      })
      setStoreSelectedProduct(remapDataProduct)

      const mappingIdProduct = remapDataProduct.map((val) => {
        return `${val.value}`
      })
      setProductIds(mappingIdProduct)

      handleGetListProduct()
    } catch (error) {
      console.log(error)
    }
  }

  const handleGetListProduct = useDebouncedCallback(async (productIds) => {
    setLoadingProducts(true)
    const parameter = {
      'filter[id][in]': productIds,
      'filter[title][like]': searchProduct,
      'page[num]': 1,
      'page[limit]': 20,
    }
    try {
      const response = await getAllProductsList(parameter)
      const responseProduct = response.data
      let dataProduct = []
      const remapDataProduct = responseProduct.map((val) => {
        return {
          label: val.attributes.title,
          value: `${val.attributes.id}`,
          image: val.attributes.image
        }
      })

      if (storeSelectedProduct.length > 0) {
        const joinData = remapDataProduct.concat(storeSelectedProduct)
        const findDuplicate = joinData.reduce((result, item) => {
          const removed = result.filter((val) => val.value !== item.value)
          return [...removed, item]
        }, [])
        dataProduct = findDuplicate
      } else {
        dataProduct = remapDataProduct
      }

      setProductList(dataProduct)
      setProductCount(remapDataProduct.length)
    } catch (error) {
      console.log(error)
    } finally {
      setLoadingProducts(false)
    }
  }, 500)

  useEffect(() => {
    if (dataProductIds.length !== 0) {
      handleGetProductListSelected(dataProductIds)
    }
    // eslint-disable-next-line
  }, [])

  useEffect(() => {
    handleGetListProduct()
    // eslint-disable-next-line
  }, [searchProduct])

  const handleSelect = (valueProduct) => {
    const filteredProduct = productList.find((val) => {
      return val.value === `${valueProduct}`
    })
    setStoreSelectedProduct(oldVal => [...oldVal, filteredProduct])

    const mappingIdProduct = [...productIds, filteredProduct.value]
    setProductIds(mappingIdProduct)

    // emmit to parent
    onChange(mappingIdProduct)
  }

  const handleUnselectProduct = (valueProduct) => {
    const unselectProduct = storeSelectedProduct.filter((val) => {
      return val.value !== `${valueProduct}`
    })
    setStoreSelectedProduct(unselectProduct)
    const mappingIdProduct = unselectProduct.map((val) => {
      return `${val.value}`
    })
    setProductIds(mappingIdProduct)

    // emmit to parent
    onChange(mappingIdProduct)
  }

  const loadingDataProduct = () => {
    return (
      <Box ta='center' my={12}>
        <Loader size={16} />
        <Text c='gray.6' fz={11}>Loading Data</Text>
      </Box>
    )
  }

  const renderProductOption = ({ option }) => {
    return (
      <Group justify='space-between' align='center' gap="xs">
        <Flex gap='sm' align='center'>
          <Paper shadow="sm" w={52} withBorder radius='md'>
            <Image w={50} h={50} radius='md' src={option.image} />
          </Paper>
          <Box>
            <Text fz={12} fw='600' lineClamp={2}>{option.label}</Text>
          </Box>
        </Flex>
      </Group>
    )
  }

  return (
    <MultiSelect
      name='input_products_banner'
      label='Products'
      value={productIds}
      data={productList}
      defaultValue={productIds}
      onOptionSubmit={(val) => handleSelect(val)}
      onRemove={(val) => handleUnselectProduct(val)}
      size='xs'
      searchable
      searchValue={searchProduct}
      onSearchChange={setSearchProduct}
      renderOption={renderProductOption}
      nothingFoundMessage={!loadingProducts ? productCount > 0 ? '' : 'No Product Found' : loadingDataProduct()}
      hidePickedOptions
      withAsterisk
      error={isError && 'Products is Required'}
    />
  )
}

export default InputProductActionBanner